import { clamp } from '../utils.mjs';
var number = {
  test: function test(v) {
    return typeof v === 'number';
  },
  parse: parseFloat,
  transform: function transform(v) {
    return v;
  }
};
var alpha = Object.assign(Object.assign({}, number), {
  transform: clamp(0, 1)
});
var scale = Object.assign(Object.assign({}, number), {
  default: 1
});
export { alpha, number, scale };